import React, { useEffect, useState } from "react";
import {
  REACT_APP_PROD_URL,
  PRICES_URL,
  CENTRIFUGE_ENDPOINT,
  CENTRIFUGE_TOKEN,
} from "../../services/configs";
import { useDispatch, useSelector } from "react-redux";
import { UPDATE_PRICES } from "../../redux/priceReducer";
import FallbackComponent from "../FallbackComponent";
import { Button, Divider, Typography } from "@material-ui/core";
import { useLocation } from "react-router";
import queryString from "query-string";
import { SET_IGNORE_MOBILE_APP, SET_REFERRAL } from "../../redux/types";
import { useDialog } from "../../contexts/DialogProvider";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { isMobile, isIOS } from "react-device-detect";
import {
  makeStyles,
  withStyles,
  useTheme,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import { FaTimes } from "react-icons/fa";
import Drawer from "@material-ui/core/Drawer";
import CENTRIFUGE_OBJ from "../../services/centrifuge";
import { cryptoinrWebsocketChannel } from "../../services/configs";
// import SockJS from "sockjs-client";

export default function Root({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  let params = queryString.parse(location.search);
  const [openDialog, closeDialog] = useDialog();

  const setReferral = (referral) => {
    dispatch({ type: SET_REFERRAL, payload: referral });
  };

  const handleNewPrices = (data) => {
    // console.log(`C`, Date.now());

    // {0:"s", 1:"a", 2:"b", 3:"hb", 4:"hs", 5:"lb", 6:"ls"}

    const temp = data.reduce(function (acc, value) {
      // console.log(value);
      acc[value[0]] = {
        s: value[0],
        a: value[1],
        b: value[2],
        hb: value[3],
        hs: value[4],
        lb: value[5],
        ls: value[6],
        hrb: value[10],
        hrs: value[11],
      };
      return acc;
    }, {});
    dispatch({ type: "UPDATE_PRICES", payload: temp });
  };

  const refreshPagePopup = (data) => {
    showRefreshPagePopup(data);
  };

  // function bindWithChunking(channel, event, callback) {
  //   channel.bind(event, callback); // Allow normal unchunked events.
  //   // Now the chunked variation. Allows arbitrarily long messages.
  //   var events = {};
  //   channel.bind("chunked-" + event, (data) => {
  //     // if (data.index == 0) console.log(`C`, Date.now());

  //     if (!events.hasOwnProperty(data.id)) {
  //       events[data.id] = { chunks: [], receivedFinal: false };
  //     }
  //     var ev = events[data.id];
  //     ev.chunks[data.index] = data.chunk;
  //     if (data.isFinal) ev.receivedFinal = true;

  //     if (
  //       ev.receivedFinal &&
  //       ev.chunks.length === Object.keys(ev.chunks).length
  //     ) {
  //       callback([].concat.apply([], ev.chunks));
  //       delete events[data.id];
  //     }
  //   });
  // }

  function showRefreshPagePopup(data) {
    openDialog({
      children: (
        <>
          <DialogTitle>PocketBits updated! 🎉</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {data}
            </DialogContentText>
          </DialogContent>
          <DialogActions
            style={{ paddingBottom: "30px", paddingRight: "20px" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.location.reload();
              }}
              style={{ color: "white", fontWeight: "bold" }}
            >
              Refresh
            </Button>
          </DialogActions>
        </>
      ),
    });
  }

  useEffect(() => {
    dispatch({ type: "SET_DARK_MODE", payload: true });

    CENTRIFUGE_OBJ.centrifuge.connect();
    CENTRIFUGE_OBJ.centrifuge.setToken(CENTRIFUGE_TOKEN);

    CENTRIFUGE_OBJ.centrifuge.subscribe(
      `site-update${CENTRIFUGE_OBJ.env}`,
      ({ data }) => {
        console.log(data);
        refreshPagePopup(data);
      }
    );

    CENTRIFUGE_OBJ.centrifuge.subscribe(
      cryptoinrWebsocketChannel,
      ({ data }) => {
        handleNewPrices(data);
      }
    );

    if (Boolean(params.ref)) {
      setReferral(params.ref);
    }

    return () => {
      CENTRIFUGE_OBJ.centrifuge.disconnect();
    };
  }, []);

  return <>{children}</>;
}
